import React, { Component } from 'react';

const defaultProps = {
    defaultValue: null,
    defaultInputValue: '',
    defaultMenuIsOpen: false,
    value: undefined,
    inputValue: undefined,
    menuIsOpen: undefined,
};


export const withState = SelectComponent => (
    class StateManager extends Component {
        static defaultProps = defaultProps;

        constructor(props) {
            super(props);

            const {
                value, defaultValue,
                inputValue, defaultInputValue,
                menuIsOpen, defaultMenuIsOpen,
            } = this.props;

            this.state = {
                value: value !== undefined ? value : defaultValue,
                inputValue: inputValue !== undefined ? inputValue : defaultInputValue,
                menuIsOpen: menuIsOpen !== undefined ? menuIsOpen : defaultMenuIsOpen,
            };
        }

        focus() {
            this.select.focus();
        }

        blur() {
            this.select.blur();
        }

        getProp(key) {
            const { [key]: prop } = this.props;
            const { [key]: state } = this.state;
            return prop !== undefined ? prop : state;
        }

        callProp(key, ...args) {
            const { [key]: prop } = this.props;
            return typeof prop === 'function'
                ? prop(...args)
                : undefined;
        }

        onChange = (value, actionMeta) => {
            this.callProp('onChange', value, actionMeta);
            this.setState({ value });
        };

        onInputChange = (inputValue, actionMeta) => {
            this.callProp('onInputChange', inputValue, actionMeta);
            this.setState({ inputValue });
        };

        onMenuOpen = () => {
            this.callProp('onMenuOpen');
            this.setState({ menuIsOpen: true });
        };

        onMenuClose = () => {
            this.callProp('onMenuClose');
            this.setState({ menuIsOpen: false });
        };

        render() {
            const {
                defaultValue,
                defaultInputValue,
                defaultMenuIsOpen,
                ...props
            } = this.props;

            return (
                <SelectComponent
                    {...props}
                    ref={(ref) => { this.select = ref; }}
                    value={this.getProp('value')}
                    inputValue={this.getProp('inputValue')}
                    menuIsOpen={this.getProp('menuIsOpen')}
                    onChange={this.onChange}
                    onInputChange={this.onInputChange}
                    onMenuOpen={this.onMenuOpen}
                    onMenuClose={this.onMenuClose}
                />
            );
        }
    }
);
